import { Cookie as CookieNames } from '@ps/web-core-enums';
import { keyBy, mapValues } from 'lodash';
import Cookies from 'universal-cookie';

import type { ModelConfig } from '@swf/core/store';
import type {
  Counter,
  Notification,
  PSNPartnerNotification,
  TemplateID
} from '@swf/core/types/Notification';

import effects from './effects';
import reducers from './reducers';
import selectors from './selectors';

export enum ErrorCode {
  INSUFFICIENT_FUNDS = 5
}

export interface NotificationStateProps {
  submitted?: boolean;
  hasError?: boolean;
  clearbets?: number;
  notificationid?: number;
  rollid?: number;
  errorCode?: ErrorCode;
}

export interface NotificationState {
  issued: Record<string, Notification>;
  expiring: Record<string, Notification>;
  cleared: Record<string, Notification>;
  counters: Counter;
  cookies: {
    [CookieNames.DOWNLOAD_BANNER]?: boolean;
    [CookieNames.ADD_TO_HOME_SCREEN]?: boolean;
  };
  PSNPartnerNotifications: Record<TemplateID, PSNPartnerNotification[]>;
}

export interface NotificationModel extends ModelConfig<NotificationState> {
  reducers: typeof reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

const cookies = new Cookies();
const notification: NotificationModel = {
  state: {
    issued: {},
    expiring: {},
    cleared: {},
    counters: {
      freeBetCounter: 0,
      freeCardCounter: 0,
      freeSpinCounter: 0,
      instantBonusCounter: 0,
      ispFreeBetsCounter: 0,
      prizeGameCounter: 0,
      sportsCashBonusCounter: 0,
      releaseBonusCounter: 0,
      tournamentTicketCounter: 0
    },
    cookies: mapValues(
      keyBy([CookieNames.DOWNLOAD_BANNER, CookieNames.ADD_TO_HOME_SCREEN]),
      (name) => cookies.get(name) !== 'false'
    ),
    PSNPartnerNotifications: {}
  },
  effects,
  reducers,
  selectors
};

export default notification;
